import { updateWineName } from "../MenuCMS/wineText";
const modifierKeys = ["options", "sauces", "pastas", "platters"];

export function cmsTextChange(menus, binding, text) {
  const [type, id, field] = binding.split(":");
  const sections = Object.values(menus || {}).flatMap((menu) => menu?.sections || []);
  const source = type === "section" ? sections.find((s) => s._id === id)
    : sections.flatMap((s) => s.items || []).find((item) => item._id === id);
  if (!source) throw new Error("This CMS item is no longer available. Reopen the menu to refresh it.");
  const changes = {}, expected = {};
  if (type === "item" && ["wineLabel", "wineOrigin", "wineType", "wineMaker", "wineMakerOrigin"].includes(field)) {
    changes.name = updateWineName(source.name, field, text);
    expected.name = source.name || "";
  } else if ((type === "section" && ["header", "description"].includes(field)) ||
      (type === "item" && ["name", "description"].includes(field))) {
    if (field !== "description" && !text.trim()) throw new Error("The name cannot be empty.");
    changes[field] = text;
    expected[field] = source[field] || "";
  } else if (type === "item" && field === "price") {
    const marketPrice = /^market\s+price$/i.test(text.trim());
    const parts = marketPrice ? [] : text.split(/\s*[•·]\s*/);
    if (!marketPrice && parts.length !== Math.max(1, source.price.length)) throw new Error(`Enter ${Math.max(1, source.price.length)} price${source.price.length <= 1 ? "" : "s"}, separated by •, or market price.`);
    changes.price = parts.map((part, index) => {
      const label = source.sizes?.[index]?.name;
      let value = part.trim();
      if (label && value.toLowerCase().startsWith(label.toLowerCase())) value = value.slice(label.length).trim();
      value = value.replace(/^\$\s*/, "");
      if (!/^\d+(?:\.\d{1,2})?$/.test(value) || Number(value) > 100000) throw new Error("Use valid non-negative prices, with at most two decimal places.");
      return Number(value);
    });
    expected.price = source.price;
  } else if (type === "item" && field === "modifiers") {
    const entries = modifierKeys.flatMap((key) => (source[key] || []).filter((entry) => entry.name?.trim()).map((entry) => ({ key, entry })));
    const parts = text.split(/\s*·\s*/);
    if (parts.length !== entries.length) throw new Error("Keep one option per existing entry, separated by ·.");
    entries.forEach(({ key, entry }, index) => {
      const match = parts[index].match(/^(.+?)(?:\s+\+(\d+(?:\.\d{1,2})?))?$/);
      if (!match || !match[1].trim()) throw new Error("Each option needs a name and an optional +price.");
      if (!changes[key]) { changes[key] = source[key].map((v) => ({ ...v })); expected[key] = source[key]; }
      const target = changes[key].find((v) => v._id === entry._id);
      Object.assign(target, { name: match[1].trim(), price: Number(match[2] || 0) });
    });
  } else if (["sauceNames", "saucePrices", "sizeLabels"].includes(field)) {
    throw new Error("Edit this item’s Sauces and Sizes in the CMS; the menu updates from those values.");
  } else throw new Error("This text cannot be mapped to a CMS field.");
  return { type, id, changes, expected };
}

export function replaceCmsSource(menus, type, updated) {
  return Object.fromEntries(Object.entries(menus).map(([key, menu]) => [key, {
    ...menu, sections: menu.sections.map((section) => type === "section" && section._id === updated._id
      ? { ...section, ...updated, items: section.items }
      : { ...section, items: section.items.map((item) => type === "item" && item._id === updated._id ? updated : item) }),
  }]));
}
